import SearchModel from'./SearchModel';
class TraitorModel {
    id = -1
    name              = ""
    bdate          = ""
    adres             = ""
    phone              = ""
    ipm          = ""
    dosc         = ""
    link            = ""
    rel    = ""
    infoTraitor     = ""
    
    searchModel = null;
}

export default TraitorModel